module.exports = __webpack_public_path__ + "static/media/bpharm2.13770d4d.jpg";